const GithubLogo = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="#191717"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.506 0.000244805C9.65529 -0.000703232 6.89732 1.01307 4.72588 2.86005C2.55443 4.70703 1.1113 7.26662 0.654868 10.0805C0.198433 12.8945 0.758496 15.779 2.23478 18.2177C3.71107 20.6563 6.00718 22.4899 8.71202 23.3901C9.30825 23.5014 9.53084 23.1297 9.53084 22.8117C9.53084 22.5256 9.5209 21.5815 9.51494 20.5779C6.17609 21.3033 5.47254 19.1629 5.47254 19.1629C4.92601 17.7717 4.13899 17.406 4.13899 17.406C3.04989 16.6607 4.22048 16.6766 4.22048 16.6766C5.42683 16.7621 6.06082 17.9128 6.06082 17.9128C7.13203 19.7472 8.86903 19.2185 9.5527 18.9065C9.66201 18.1314 9.97204 17.6027 10.3159 17.3026C7.6587 17.0025 4.84651 15.9731 4.84651 11.3742C4.82867 10.1797 5.27216 9.02437 6.08467 8.14863C5.95946 7.84654 5.54807 6.62627 6.19994 4.96877C6.19994 4.96877 7.20755 4.64681 9.50103 6.19898C11.4689 5.66104 13.5451 5.66104 15.5129 6.19898C17.7945 4.65476 18.8101 4.96877 18.8101 4.96877C19.4619 6.6223 19.0525 7.84257 18.9273 8.14863C19.7376 9.02388 20.1796 10.1776 20.1615 11.3702C20.1615 15.981 17.3553 16.9946 14.6822 17.2927C15.1115 17.6644 15.4951 18.3957 15.4951 19.5146C15.4951 21.1205 15.4831 22.4143 15.4831 22.8078C15.4831 23.1277 15.6978 23.5014 16.3059 23.3841C19.0068 22.4805 21.2984 20.6459 22.7711 18.2081C24.2437 15.7703 24.8015 12.8883 24.3447 10.0771C23.8878 7.26594 22.4462 4.70881 20.2774 2.86278C18.1086 1.01675 15.3541 0.00212153 12.506 0.000244805V0.000244805Z"
        fill="inherit"
      />
      <path
        d="M5.04928 17.2312C5.02344 17.2908 4.93003 17.3087 4.85054 17.2689C4.77104 17.2292 4.7134 17.1477 4.74123 17.0881C4.76905 17.0285 4.86246 17.0106 4.93997 17.0503C5.01748 17.0901 5.0771 17.1715 5.04729 17.2312H5.04928Z"
        fill="inherit"
      />
      <path
        d="M5.53621 17.7736C5.47857 17.8272 5.36728 17.8014 5.28977 17.7179C5.25354 17.6886 5.22987 17.6466 5.22359 17.6004C5.21731 17.5542 5.2289 17.5074 5.25598 17.4695C5.31561 17.4158 5.42293 17.4417 5.50242 17.5251C5.58192 17.6086 5.59583 17.7239 5.53621 17.7736Z"
        fill="inherit"
      />
      <path
        d="M6.00923 18.4653C5.93569 18.5169 5.81049 18.4653 5.74093 18.3619C5.67137 18.2586 5.66739 18.1274 5.74093 18.0757C5.81446 18.0241 5.93967 18.0757 6.00923 18.1771C6.07879 18.2784 6.08276 18.4136 6.00923 18.4653V18.4653Z"
        fill="inherit"
      />
      <path
        d="M6.66531 19.1329C6.64114 19.1504 6.61372 19.1629 6.58466 19.1697C6.55559 19.1765 6.52547 19.1774 6.49605 19.1724C6.46663 19.1674 6.4385 19.1566 6.41331 19.1406C6.38811 19.1246 6.36636 19.1037 6.34931 19.0792C6.24398 18.9819 6.21417 18.8447 6.28174 18.7732C6.34931 18.7016 6.48048 18.7195 6.59178 18.8189C6.70307 18.9183 6.72692 19.0534 6.65736 19.125L6.66531 19.1329Z"
        fill="inherit"
      />
      <path
        d="M7.55121 19.5206C7.5214 19.614 7.38824 19.6577 7.25111 19.6179C7.11398 19.5782 7.02653 19.4669 7.05237 19.3715C7.07821 19.2761 7.21534 19.2324 7.35247 19.2741C7.4896 19.3159 7.57705 19.4252 7.55121 19.5206Z"
        fill="inherit"
      />
      <path
        d="M8.53332 19.5922C8.53332 19.6915 8.42202 19.773 8.27893 19.775C8.13584 19.777 8.02057 19.6995 8.01858 19.6001C8.01659 19.5007 8.12987 19.4193 8.27496 19.4173C8.42004 19.4153 8.53332 19.4948 8.53332 19.5922V19.5922Z"
        fill="inherit"
      />
      <path
        d="M9.44759 19.4371C9.46548 19.5345 9.36611 19.6358 9.225 19.6597C9.0839 19.6835 8.9567 19.6259 8.93882 19.5285C8.92093 19.4311 9.02229 19.3298 9.16141 19.3059C9.30053 19.2821 9.42971 19.3397 9.44759 19.4371Z"
        fill="inherit"
      />
    </svg>
  );
};

export default GithubLogo;
